import game from "./../../game";

// returns the camera object
export default function getCamera() {
  return [game.game.pseudoCamera];
}
